<template>
  <div class="relative">
    <div class="mx-auto max-w-7xl">
      <div class="relative z-10 pt-14 lg:w-full lg:max-w-2xl">
        <!-- Background SVG Slicing image -->
        <svg
          class="absolute inset-y-0 right-8 hidden h-full w-80 translate-x-1/2
              transform fill-gray-100 dark:fill-gray-900 lg:block"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <polygon points="0,0 90,0 50,100 0,100" />
        </svg>

        <!-- Main content -->
        <div class="relative px-8 sm:px-none py-16 sm:py-32 lg:pr-0">
          <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
            <div class="hidden sm:mb-10 sm:flex">
              <UiTag
                href="#"
                :link-text="t('pages.home.mainSection.about-anchor')"
              >
                {{ t('pages.home.mainSection.tag') }}
              </UiTag>
            </div>
            <UiTitle
              size="7xl"
              align="left"
              color="gray"
            >
              {{ t('pages.home.mainSection.title') }}
            </UiTitle>
            <UiParagraph
              size="xl"
              align="left"
              color="gray"
              class="mt-8"
            >
              {{ t('pages.home.mainSection.description') }}
            </UiParagraph>
            <div class="mt-10 flex items-center gap-x-6">
              <UiButton
                variant="primary"
                size="md"
                @click="openForm()"
              >
                {{ t('pages.home.mainSection.button') }}
              </UiButton>
              <UiButton
                variant="ghost"
                size="md"
                @click="navigateTo('how-it-works')"
              >
                {{ t('pages.home.mainSection.learn-button') }}
                <span
                  aria-hidden="true"
                  class="ml-2"
                >→</span>
              </UiButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
      <img
        class="aspect-3/2 object-cover lg:aspect-auto lg:size-full"
        src="@/assets/images/landing/main/cover.webp"
        alt=""
      >
      <!-- <img
        class="aspect-3/2 object-cover lg:aspect-auto lg:size-full"
        src="https://images.unsplash.com/photo-1483389127117-b6a2102724ae?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1587&q=80"
        alt=""
      > -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import UiTag from '@/components/ui/UiTag.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import UiButton from '@/components/ui/UiButton.vue';

const { t } = useI18n();

// Methods
const openForm = () => {
  window.open(t('pages.home.mainSection.form-url'), '_blank');
};

const navigateTo = (id: string) => {
  const element = document.getElementById(id);
  element?.scrollIntoView({ behavior: 'smooth' });
};
</script>
